module.exports = __webpack_public_path__ + "static/media/wood_floor_pillar.767086d0.png";